module.exports = __webpack_public_path__ + "static/media/broken-link.46060d33.png";